import { render, staticRenderFns } from "./FAreaMarker.vue?vue&type=template&id=5af025f2"
import script from "./FAreaMarker.vue?vue&type=script&lang=js"
export * from "./FAreaMarker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports